import api from './api';

const resource = 'Product/';

export const list = async (query) => {
  return await api.get(resource + 'List?PageSize=1000' + query);
};

export const getById = async (id) => {
  return await api.get(resource + 'Get?id=' + id);
};

export const upsert = async (body, config) => {
  return await api.post(resource + 'Upsert', body, config);
};

export const duplicate = async (id) => {
  return await api.post(resource + 'Duplicate?id=' + id);
};

export const deleteById = async (id) => {
  return await api.delete(resource + 'Delete?id=' + id);
};

export const deleteImageById = async (id) => {
  return await api.delete(resource + 'DeleteImage?productId=' + id);
};

export const updateSchedules = async (body) => {
  return await api.put(resource + 'UpdateSchedules', body);
};

export const getByStoreId = async (storeId) => {
  return await api.get(resource + 'GetByStoreId?storeId=' + storeId);
};

export const reorder = async (body) => {
  return await api.post(resource + 'Reorder', body);
};

export const needsReview = async (menuid) => {
  return await api.get(
    resource + 'NeedsReview?menuid=' + encodeURIComponent(menuid)
  );
};

const productApi = {
  list,
  getById,
  upsert,
  duplicate,
  deleteById,
  deleteImageById,
  updateSchedules,
  getByStoreId,
  reorder,
  needsReview,
};

export default productApi;
